declare var showConfirmDialog: any;
import { Component, OnInit, ViewChild } from '@angular/core';
import { PointStoreProductOrderService } from '../../../agent-side/services/point-store-product-order.service';
import { PointStoreProductEditService } from '../../services/point-store-product-edit.service';
import { CVLocalizationService } from '../../../../../reusables/services/cv-localization.service';
import { MarketplaceOrdersTableComponentComponent } from 'src/app/gamification/marketplace/admin/components/marketplace-orders-table-component/marketplace-orders-table-component.component';

@Component({
    selector: 'cv-point-store-orders-admin',
    templateUrl: './point-store-orders-admin.component.html',
    styleUrls: ['./point-store-orders-admin.component.scss']
})

export class PointStoreOrdersAdminComponent implements OnInit {
    
    @ViewChild(MarketplaceOrdersTableComponentComponent) ordersTable!: MarketplaceOrdersTableComponentComponent;
    pspos = null;
    DateFormat = CVAngularDateFormat;
    OriginalOrders = null;
    EnableEdit = false;
    SelectionCounter = 0; //Default value for the selection action bar's visibility conditional. Manually managed rather than dynamically calculated for efficiency's sake.

    constructor(
        private pointStoreProductOrderService: PointStoreProductOrderService,
        private pointStoreProductEditService: PointStoreProductEditService,
        private cvLocalizationService: CVLocalizationService,
    ) { }

    ngOnInit(): void {
        this.pspos = this.pointStoreProductOrderService.pointStoreProductOrderObj;
        this.pointStoreProductOrderService.LoadPointStoreProductAdminOrders();
        this.pointStoreProductOrderService.loadOrderStatusName();
        this.pointStoreProductOrderService.loadMessages();
    }

    async onOrderUpdated(e) {
        this.pointStoreProductOrderService.pointStoreProductOrderObj.opc = 'orders';
        this.pspos.validateCompleteFlag = false;
        this.pspos.validateCompleteFlagResult = false;
        this.pspos.validateCancelledFlag = false;
        this.pspos.validateCancelledFlagResult = false;
    
        // Don't allow to cancel orders with completed products
        const containsCompletedProducts = e.oldValue.ProductsCollection.some(p => p._PointStoreProductOrderedDTO.ProductStatus === 4);
    
        if ((e.oldValue.OrderStatus == 4 || e.oldValue.OrderStatus == 5) || (e.newValue.OrderStatus === 5 && containsCompletedProducts)) {
            new showConfirmDialog(await this.cvLocalizationService.GetLocalText("MarketPlace_Management_Messages", "You_Cannot_Change_The_Status", "You cannot change the status from complete or cancelled status"),
                [
                    {
                        text: "OK",
                        click: function () {
                            let errorDialog: any = $(".errorDialog");
                            errorDialog.dialog("close");
                        }
                    }
                ], await this.cvLocalizationService.GetLocalText("MarketPlace_Management_Messages", "Order_Management_Validation_Warning", "MarketPlace Order Management Validation Warning"), "warning");
               
            this.pointStoreProductOrderService.LoadPointStoreProductAdminOrders();
            return;
        }
       
        //Handle Complete Action
        if ((e.newValue.OrderStatus === 4 && e.oldValue.OrderStatus !== 4) && e.oldValue.OrderStatus !== 5) {
            // marked completed - validation modal
            const result = await this.pointStoreProductOrderService.validateChangeStatusComplete();
            this.pspos.validateCompleteFlag = true;
            this.pspos.validateCompleteFlagResult = result;
            if (!result) {
                await this.pointStoreProductEditService.LoadPointStoreProducts();
                return;
            } 

            this.pspos.isloadingExternalFilter = true;
            this.pspos.originalPointStoreProductOrder = e.oldValue;
            await this.pointStoreProductOrderService.EditPointStoreProductAdminOrder(e.newValue);
            await this.pointStoreProductEditService.LoadPointStoreProducts();
            
        //Handle Cancelled Action
        } else if ((e.newValue.OrderStatus === 5 && e.oldValue.OrderStatus !== 5) && e.oldValue.OrderStatus !== 4) {
            // marked cancelled - validation modal
            const result = await this.pointStoreProductOrderService.validateChangeStatusCancelled();
            this.pspos.validateCancelledFlag = true;
            this.pspos.validateCancelledFlagResult = result;
            if (!result) {
                await this.pointStoreProductEditService.LoadPointStoreProducts();
                return;
            } 

            this.pspos.isloadingExternalFilter = true;
            this.pspos.originalPointStoreProductOrder = e.oldValue;
            await this.pointStoreProductOrderService.EditPointStoreProductAdminOrder(e.newValue);

            if (this.pointStoreProductEditService.pointStoreProductEditObj.collection.isLoaded) {
                this.pointStoreProductEditService.pointStoreProductEditObj.collection.isLoaded = false;
            }
            await this.pointStoreProductEditService.LoadPointStoreProducts();

        // Handle other status changes
        } else {
            this.pspos.isloadingExternalFilter = true;
            this.pspos.originalPointStoreProductOrder = e.oldValue;

            try {
                await this.pointStoreProductOrderService.EditPointStoreProductAdminOrder(e.newValue);
                await this.pointStoreProductEditService.LoadPointStoreProducts();
            } catch (error) {
                console.error(error);
                this.pspos.isloadingExternalFilter = false;
            }
        }
    }
    


    clickEdit(order) {
        this.pointStoreProductOrderService.clickEdit(order);
    };
    clickCancel(order) {
        this.pointStoreProductOrderService.clickCancel(order);
    };
    clickUpdate(order) {
        this.pointStoreProductOrderService.EditPointStoreProductAdminOrder(order);
        order.clickEdited = false;
    };

    clickOpenClose(order, event) {
        //Page functionality is weird. When enter or space is pressed while an order's notes input is active, 
        //  the details box collapses with this function called. StopPropagation doesn't quite do the *full* trick for this rogue input field, either.
        //So, check first if enter (13) or space (32) is the cause of the event. 
        //If so, do nothing and immediately return. Otherwise, toggle the order details.
        if (event.type === "keypress" && (event.charCode === 32 || event.charCode === 13))
            return;

        this.pointStoreProductOrderService.clickOpenClose(order);

    };
    stopEventPropagation(e) {
        e.stopPropagation();
        return false;
    }
    getOrderStatusName(OrderStatus) {
        return this.pointStoreProductOrderService.getOrderStatusName(OrderStatus);
    };

    setSortAdminList(i) {
        return this.pointStoreProductOrderService.setSortListAdmin(i);
    };
    isCurrentColumnSorted(columnID) {
        if (this.pspos.pointStoreProductOrderAdminSort[columnID].sort == true)
            return true;
        else
            return false;
    };
    getPointStoreProductOrderCSSSortAdmin(i) {
        return this.pointStoreProductOrderService.getPointStoreProductOrderCSSSortAdmin(i);
    };
    getPointStoreProductOrderCssCoinsColor(coins) {
        return this.pointStoreProductOrderService.getPointStoreProductOrderCssCoinsColor(coins);
    };
    getPointStoreProductOrderValueCoins(coins) {
        return this.pointStoreProductOrderService.getPointStoreProductOrderValueCoins(coins);
    };
    changeStatusOrderDetail(order) {
        this.pointStoreProductOrderService.changeStatusOrderDetail(order);
    };
    changeStatusOrder(order) {
        this.pointStoreProductOrderService.changeStatusOrder(order);
    };
    filterMatches(item) {
        //return this.pointStoreProductOrderService.setFilterMatches(item);
        return this.pointStoreProductOrderService.setFilterMatchesEmpGroup(item);
    };

    /* ----- Order Selections and Actions ----- */
    /* NOTE */
    /* When enabling edit or cancelling edit, the array of order objects is deep copied (JSON parse + stringify),
     *  as other copy options retain object references, which defeats the purpose of copying the array.
     * Other array-copy options (e.g., .slice()) copies objects by reference, unfortunately.
    */
    SelectOrder(order) {
        //Set selection counter value
        this.SelectionCounter = this.pspos.adminOrders.filter((o) => { return o.IsSelected == true }).length;
    }

    CancelEdit() {
        //Restore the original copy

        this.pspos.adminOrders = angular.copy(this.OriginalOrders);

        //Enable all the checkboxes
        $('#agent-order-history-body').find(':checkbox').prop('disabled', false);
        this.EnableEdit = false;
    }

    SelectEdit() {

        this.OriginalOrders = angular.copy(this.pspos.adminOrders);

        //Expand all selected objects that are not expanded
        this.pspos.adminOrders.forEach((o) => {
            if (o.IsSelected && !o.clickExpanded)
                o.clickExpanded = true;
        });

        //Disable all checkboxes
        $('#agent-order-history-body').find(':checkbox').prop('disabled', true);
        this.EnableEdit = true;
    }

    SelectCancel() {
        this.EnableEdit = false;

        //Handle when items are selected then the selection is cancelled (selected and/or expanded but no edit selected).
        if (this.OriginalOrders == null) {
            this.pspos.adminOrders.map((o) => {
                o.IsSelected = false;
                o.clickExpanded = false;
            });

            this.SelectionCounter = 0;
            return;
        }

        //Restore the original copy, reverting all changes.
        this.pspos.adminOrders = angular.copy(this.OriginalOrders);

        //Deselect and collapse all. (Could probably be array.map()'d).
        this.pspos.adminOrders.forEach((o) => {
            if (o.IsSelected) {
                o.IsSelected = false;
                this.SelectionCounter -= 1;

                //Commented out, not necessary - clickCancel works in a "Edit-One-Only" mode, which causes issues in this new "Edit-One-To-Many" mode.
                //this.clickCancel(o);
            }

            //Collapse all elements.
            o.clickExpanded = false;
        });

        //Enable all the checkboxes
        $('#agent-order-history-body').find(':checkbox').prop('disabled', false);

    }

    SelectSave() {
        //Cthulhu save the souls of those who tread here.
        //(Note: pspos = this.pointStoreProductOrderService ... Which is in ShoppingCartFactories.js.)

        //Make sure the "should I keep validating this???" check is reset.
        //  Two flags for two validated statuses: Complete, Cancelled
        this.pspos.validateCompleteFlag = false;        //Have I checked yet?
        this.pspos.validateCompleteFlagResult = false;  //What was the result of my check?
        this.pspos.validateCancelledFlag = false;
        this.pspos.validateCancelledFlagResult = false;

        //Dumb necesseties in reusing the "one-at-a-time" functionality in a "one-or-many-at-a-time" setup.
        //  (Could be skipped all together if there wasn't a need to validate two kinds of changes...)
        let findCompleted = false;
        let findCancelled = false;

        for (let i = 0; i < this.pspos.adminOrders.length; i++) {
            if (findCompleted && findCancelled)
                break;

            this.pspos.originalPointStoreProductOrder = this.OriginalOrders[i];

            for (let x = 0; x < this.pspos.adminOrders[i].ProductsCollection.length; x++) {
                if (this.pspos.adminOrders[i].ProductsCollection[x].ProductStatus == 4 && this.pspos.adminOrders[i].ProductsCollection[x].ProductStatus != this.pspos.originalPointStoreProductOrder.ProductsCollection[x].ProductStatus) {
                    findCompleted = true;
                } else if (this.pspos.adminOrders[i].ProductsCollection[x].ProductStatus == 5 && this.pspos.adminOrders[i].ProductsCollection[x].ProductStatus != this.pspos.originalPointStoreProductOrder.ProductsCollection[x].ProductStatus) {
                    findCancelled = true;
                }
            }
        }

        //These validation checks are daisy chained this way as a quick (and disgusting) solution to the asynchronous validation popup spam without a major rewrite to support multi-edit validation.
        //If completed status detected...
        if (findCompleted) {
            //Validate completed changes
            //this.pspos.validateChangeStatusComplete().then(function (result) { //was this.pspos.pointStoreProductOrderObj.validate...
            this.pointStoreProductOrderService.validateChangeStatusComplete().then((result) => {
                //Save the chosen action
                this.pspos.validateCompleteFlag = true;
                this.pspos.validateCompleteFlagResult = result;

                //If cancel validation is needed... othewise, just run the updates.
                if (findCancelled) {
                    //this.pspos.validateChangeStatusCancelled().then(function (result) { //was this.pspos.pointStoreProductOrderObj.validate...
                    this.pointStoreProductOrderService.validateChangeStatusCancelled().then((result) => {
                        this.pspos.validateCancelledFlag = true;
                        this.pspos.validateCancelledFlagResult = result;

                        this.ActuallySaveTheOrders();
                    });
                } else {
                    this.ActuallySaveTheOrders();
                }
            });
        } else if (findCancelled) {
            //Only validate cancelled
            //this.pspos.validateChangeStatusCancelled().then(function (result) {
            this.pointStoreProductOrderService.validateChangeStatusCancelled().then((result) => {
                this.pspos.validateCancelledFlag = true;
                this.pspos.validateCancelledFlagResult = result;

                this.ActuallySaveTheOrders();
            });
        } else {
            //Run the saves, no special cases detected.
            this.ActuallySaveTheOrders();
        }
    };

    ActuallySaveTheOrders() {
        //Flags should be set for the validations and checks. Run the updates.
        for (let i = 0; i < this.pspos.adminOrders.length; i++) {
            //If selected, update it and uncheck.
            if (this.pspos.adminOrders[i].IsSelected) {
                this.pspos.adminOrders[i].IsSelected = false;
                this.SelectionCounter -= 1;

                //Set the original (used in the update process)...
                this.pspos.originalPointStoreProductOrder = this.OriginalOrders[i];

                this.clickUpdate(this.pspos.adminOrders[i]);
            }

            //Collapse regardless of checked status.
            this.pspos.adminOrders[i].clickExpanded = false;
        }

        //Enable all the checkboxes
        $('#agent-order-history-body').find(':checkbox').prop('disabled', false);
        this.EnableEdit = false;

        //Reset the flags, post loop. Redundant, but we want to make sure things validate on each new set of changes without hiccup.
        this.pspos.validateCompleteFlag = false;
        this.pspos.validateCompleteFlagResult = false;
        this.pspos.validateCancelledFlag = false;
        this.pspos.validateCancelledFlagResult = false;
    }
}
